export default {
  mfaPage: {
    banner: {
      title: "Adaptive MFA",
      subtitle:
        "Adaptive MFA is a simple and effective best security practice method. It can add an extra layer of security protection in addition to the user name and password, and perform secure identity verification without sacrificing user experience.",
      bannerImg: "//files.authing.co/authing-website/mfa-banner-img-new-en.png",
    },
    advantageData: {
      0: { label: "Reduce security risks", value: "75%" },
      1: { label: "Improve user efficiency", value: "50%" },
      2: { label: "Reduce the risk of data leakage", value: "90%" },
    },
    features: {
      blockOne: {
        title: "More security, better experience, higher performance",
        descript1:
          "Compared with traditional MFA, 「Adaptive」 MFA can choose to apply different MFA methods according to the situation, so as to ensure security while also taking into account the user experience. 「Adaptive」 MFA provides a more flexible and intelligent verification strategy.",
        descript2:
          "During the user authentication process, 「Adaptive」 MFA generates a variety of key elements for the logged-in user.",
        item1: {
          title: "User Attributes",
          descript:
            "User attributes and information such as user name, password, user identity, etc.",
        },
        item2: {
          title: "Location Awareness",
          descript:
            "Location awareness is divided into virtual location (IP address) and physical location (country, region, etc.)",
        },
        item3: {
          title: "Behavior Analysis",
          descript:
            "Whether it comes from a frequently used login location, whether the wrong password has been entered multiple times, the user's previous operation records, and a series of user behaviors",
        },
        item4: {
          title: "Request source",
          descript:
            "Judging the source of the current user's request, such as: hardware device information, the user's current system, etc.",
        },
        item5: {
          title: "Biometrics",
          descript:
            "Use the user's biological information for identification, such as fingerprint information, face recognition, etc.",
        },
      },
      blockTwo: {
        title: "Protect users from credential theft and fraud",
        descript1:
          "MFA is one of the best ways to prevent account theft. If a hacker wants to hack into an account protected by MFA, not only need to steal the credentials, but also need to verify additional factors.",
        descript2:
          "Generally, we see a tendency to use MFA in industries dealing with sensitive data. There is no additional identity layer in these verticals, so there is an urgent need for MFA.",
      },
      blockThree: {
        imgUrl:
          "//files.authing.co/authing-website/mfa-flexiable-img-new-en.png",
        title:
          "Multiple capabilities, empowering the flexibility of identity authentication",
        descript:
          "Authing can centrally configure a variety of authentication factors other than passwords, including dynamic tokens, faces, fingerprints and other biological characteristics. At the same time, it provides a developer API to support other applications to use IDaaS's identity authentication capabilities.",
      },
    },
    advantage: {
      title: "Advantages of using adaptive MFA",
      item1: {
        title: "Friendly to developers",
        descript:
          "Provides SDK to facilitate client developers to quickly implement MFA",
        list1: "Support multiple terminals: Web, iOS, Android",
        list2:
          "Built-in multiple MFA terminal components, such as OTP, verification code, fingerprint unlocking, facial recognition, graphic lock, etc.",
        list3: "Just call a method to evoke the MFA authentication component",
      },
      item2: {
        title: "Customized data reporting",
        descript:
          "Participating in the process to initiate decision-making, covering more complex and refined scenarios",
        list1: "Support data reporting during Authing SDK initialization",
        list2: "Support timing data reporting",
        list3: "Support active data reporting when the application is running",
      },
      item3: {
        title: "Strategy-based",
        descript:
          "The strategy system is simple, efficient, complete and flexible",
        list1:
          "Simple: You can use the default security policy or preset hit conditions",
        list2:
          "Efficient: Millisecond-level judgment strategy hits, and MFA is immediately evoked",
        list3:
          "Complete: The strategy is described based on function expressions, and developers can obtain user information, equipment, network, location, behavior and other information to write strategy hit logic",
        list4:
          "Flexible: Hit judgment can be made based on multiple methods at the same time to assess risk factors at each step of the identity verification process",
      },
      item4: {
        title: "Simple configuration",
        descript:
          "Based on a friendly user interface, quickly configure MFA for specific applications",
        list1: "One-click turn on/off MFA",
        list2:
          "One-click to enable the default security policy, no need to understand the policy configuration, can also greatly improve the security of the application",
        list3:
          "Preset dozens of important and commonly used strategy hit conditions, which will take effect upon selection, and can be used by non-engineers",
      },
    },
  },
  mfa: {
    banner: {
      title: "Adaptive MFA",
      subtitle:
        "Adaptive MFA is a simple and effective security approach that goes beyond usernames and passwords to Add a layer of security. For example, U-Shield for banks and off-site login require SMS verification.",
    },
    type: {
      title: "Different types of authentication factors",
      "item-one": {
        title: "Problem checking",
        "list-one": "Problem verification",
        "list-two": "Password verification",
      },
      "item-two": {
        title: "Physical verification",
        "list-one": "One-time password",
        "list-two": "QR Code scan",
        "list-three": "APP verification",
      },
      "item-three": {
        title: "Biological verification",
        "list-one": "Fingerprint verification",
        "list-two": "Facial verification",
        "list-three": "Iris verification",
      },
    },
    advance: {
      title: "Advantages of Authing MFA",
      "descript-one":
        'Authing has a unique WeChat app "Terminal Dynamic Authentication" feature which can receive the dynamic password sent by the app to achieve MFA. The safety factor has been increased to 99.99%.',
      "descript-two":
        "Authing intelligently recognizes the security level of each user login and sets different login policies based on it, Authing sets up secondary authentication rules for different people, roles, and departments, Authing sets up secondary verification startup rules on demand for different applications, depending on the importance of the application.",
    },
  },
  sso: {
    banner: {
      "title-one": "Sign in-single",
      "title-two": "Sign-on",
      subtitle:
        "Single Sign-On is one of the solutions for integrating enterprise systems, designed for multiple applications where users need to log in only once to access all mutually trusted applications.",
    },
    platform: {
      title: "Authing SSO Platform",
      "descript-one":
        "Authing single sign-on technology enables members and customers to access any software service from a single location without any development, and unify control over identity rights.",
      "descript-two":
        "If you are a developer, Authing also supports easy single sign-on via any protocol such as OAuth2, OIDC, SAML, LDAP, etc., with a unified user pool and a minimum of five lines of code for login customization.",
    },
    scene: {
      title: "SSO applications in different scenarios",
      "item-one": {
        title: "Workforce Identity",
        "descript-one":
          "Strictly control permissions: Identity management solutions provide an easy way to control different access levels of users. When employees join the company or are promoted, they can easily assign and change permissions for different applications in one place. Companies can also easily cancel or revoke access to all different platforms.",
        "descript-two":
          "Efficient office: Authing provides a one-stop team application platform for enterprises, enabling access to any local and cloud software services in one place, and centrally control their access permissions to create an efficient office method.",
        "descript-three":
          "Easy integration: Integrating enterprise systems, bringing together thousands of integrated applications, helping companies find suitable technologies, including excellent companies such as Amazon, Higher Education Press, Southeast University, and making IT management simple.",
      },
      "item-two": {
        title: "Customer Identity",
        "descript-one":
          "Facilitate Business: In any browser, on any device, Authing can provide end-users with a cross-platform, non-differentiated Single sign-on experience. Promote customer collaboration by providing customers with a unified brand access experience.",
        "descript-two":
          "Analyze opportunities: use Authing to integrate multiple user data from different identity sources. Once desensitized, companies can use this data to effectively drive marketing and sales opportunities.",
        "descript-three":
          "Accelerated go-live: Authing provides an intuitive login interface to optimize registration and login, dramatically shortening the design cycle, saving marketing resources, and enabling rapid go-live of business applications.",
      },
      "item-tree": {
        title: "For customers",
        "descript-one":
          "Achieving customer success is our goal. As enterprises become more digital, every government and business is using or developing multiple software technologies. No matter what the platform, no matter what the technology, with Authing documentation and SDKs, you can integrate single sign-on, certification, and authorization quickly.",
      },
    },
    advance: {
      title: "Advantages of Authing SSO",
      subtitle:
        "Authing supports any protocol via OAuth2, OIDC, SAML, LDAP, etc., with a unified user pool and a minimum of six lines of code for easy single sign-on.",
      "item-one": {
        title: "High security",
        "list-one": "No password transmission during the process.",
        "list-two":
          "Regular key rotation between Authing and the docking application.",
        "list-three":
          "Using a token failure mechanism to effectively prevent man-in-the-middle attacks and replay attacks.",
        "list-four":
          "Fine-grained mapping and conversion management of user identity attributes.",
      },
      "item-two": {
        title:
          "Authing SDK support for interface-less applications or self-developed systems",
        "list-one":
          "Supports SAML, OIDC, CAS, OAuth, and other international standard protocols.",
        "list-two":
          "Set different password policies for different people (groups).",
        "list-three":
          "The application can be completed through a simple configuration to open.",
        "list-four":
          "Support for a custom standard protocol (custom protocol): nail, Tencent, etc.",
      },
      "item-three": {
        title:
          "Pre-integrated with a wide range of mainstream SaaS and on-premise applications",
        "list-one":
          "Authing provides an SDK for manufacturers without a single sign-on interface or for self-developed systems.",
        "list-two":
          "supporting multiple languages such as Java, Python, Node.js, PHP and so on.",
        "list-three":
          "Authing single sign-on access with as little as 5 lines of code.",
      },
      "item-four": {
        title: "A powerful access policy engine",
        "list-one":
          "Set corresponding access rights security policies for different departments, applications, personnel.",
        "list-two": "Other attributes as needed to improve security.",
        "list-three":
          "Integration of secondary authentication services to increase the corresponding security level.",
        "list-four": "Support any number of security policies.",
      },
    },
  },
  // ul: {
  //   0: " Guard helps developers shield themselves from many of the implementation details of low-level authentication, as well as tedious UI development.",
  //   1: "The login component (Guard) is an embeddable login form that can be configured to your needs and is recommended for single-page application. It makes it easy to add various social logins so that your users can have consistent login experience.",
  //   2: "Beautiful design that fits most modern websites with just a few tweaks to its options",
  //   3: "Cross-platform support",
  //   4: "The initialization has detailed parameters that control the behavior of the entire form",
  //   5: "Support for cumbersome and redundant functions such as mobile-password, email-password, forgotten password, password reset, etc.",
  //   6: "Your company has strict design requirements and uniformity requirements for the UI.",
  //   7: "Your company would like to make changes to the existing UI",
  //   8: "Allow front-end development experts to customize with HTML, CSS and JavaScript",
  //   9: "Founded in May 1954, Higher Education Press is one of the earliest professional educational publishing institutions in New China. It has more than 1,700 employees on staff and publishes more than 10,000 books annually, with nearly 130 million copies in circulation.",
  //   10: "Embed User Login UI Form Components - Unified Authentication - Five Line Code Access Login System - Authing",
  //   登录组件: "Login Components",
  //   免费使用: "Free Access",
  //   查看文档: "View Document",
  //   什么是登录组件: "What is login components?",
  //   登录组件接入效果: "Login component access effect",
  //   登录组件VS自定义UI: "Login component VS Customization UI",
  //   Authing通用登录表单Guard: "Authing Universal Login Form Guard",
  //   由Authing保证安全的认证: "Secure authentication by Authing",
  //   自定义UI: "Customization UI",
  //   Whatis登录组件: "What is login components?",
  //   前往社区: "Go to community",
  // },
  // 产品-单点登录新版
  ssoPage: {
    banner: {
      title: "Single Sign-On",
      subtitle:
        "Single Sign-On (SSO) means that in multiple application systems, users only need to log in once to access all mutually trusted application systems.",
      img: "//files.authing.co/authing-website/sso-banner-img-en.png",
    },
    advantageData: {
      0: { label: "Save user login time", value: "90%" },
      1: { label: "Increase IT integration speed", value: "500%" },
      2: { label: "Reduce log-in related inquiries", value: "75%" },
    },
    box_one: {
      img: "//files.authing.co/authing-website/sso-access-img-v3-en.png",
      title: "Log in once to access all apps",
      content_one:
        "Authing relies on Single Sign-On technology to enable members and customers to access any software service in one place, and uniformly control identity permissions. Users only need to log in once to use all the apps they have been granted access to.",
      content_two:
        "Authing supports many protocols such as OAuth2, OIDC, SAML, LDAP, etc. Developers can easily implement single sign-on with a minimum of five lines of code and realize login customization.",
    },
    box_two: {
      title: "Safely manage all users in one hand",
      content:
        "Building and maintaining an identity platform with SSO is expensive, and time-consuming. In a recent survey, 94% of organizations said they were able to implement Authing in less than a month. With Authing’s SSO solution you get:",
      left: {
        title: "Partner Network",
        content:
          "Authing has more than 2,000 pre-built integration networks that help you securely adopt and deploy SSO to your cloud applications without having to build and maintain your own integration.",
        link: "Explore the Partner Network",
      },
      right_one: {
        title: "A central console",
        content:
          "Authing Provides you with a central console to view, manage, and protect the access of all users, whether they are internal employees or external partners.",
        link: "Explore console",
      },
      right_two: {
        title: "Identity storage integration",
        content:
          "Authing The single sign-on solution can quickly connect to and synchronize with any number of identity stores, including AD, LDAP, HR systems, and other third-party identity providers.",
        link: "Learn more",
      },
      right_three: {
        title: "Adaptive security policy",
        content:
          "With Authing Single Sign-On, you can set the appropriate access rights for different departments, applications, people, and other properties as needed. And automatically identify and prevent malicious login, improve the corresponding security level.",
        link: "Learn more",
      },
    },
    box_three: {
      title: "SSO usages in different scenarios",
      link: "Get Started",
      0: {
        label: "EIAM",
        subLabel: "Use SSO to better manage your employees",
        content:
          "Your employees need access to a variety of services and third-party applications. Authing enables employees and partners to access any local and cloud software services in one place, centrally controls their access rights, creates an efficient way of working, simplifies personnel and IT management, and accelerates the growth of enterprises.",
        imgUrl: "//files.authing.co/authing-website/sso-inneruser-img-v2.png",
      },
      1: {
        label: "CIAM",
        subLabel: "Your users need SSO",
        content:
          'Providing a best-in-class authentication experience is critical to standing out in the never-ending competition for users. "Single sign-on" can tie together multiple apps and services for a more cohesive user experience.',
        imgUrl: "//files.authing.co/authing-website/sso-outuser-img-v2.png",
      },
      2: {
        label: "B2B",
        subLabel: "Grow your business with multi-tenant SSO",
        content:
          'Enterprises need "single sign-on" to integrate applications and support syndication clients such as Active Directory, LDAP, or Ping. Single sign-on shortens the sales cycle, is a catalyst for growth, and is a must for enterprise customers.',
        imgUrl: "//files.authing.co/authing-website/sso-develop-img-v2.png",
      },
    },
  },
  // comp: {
  //   banner: {
  //     title: "Universal Login",
  //     subtitle:
  //       "The guard helps developers shield themselves from many of the implementation details of low-level authentication, as well as tedious UI development.",
  //   },
  //   comp: {
  //     title: "What is login components?",
  //     descript:
  //       "The login component (Guard) is an embeddable login form that can be configured to your needs and is recommended for single-page application. It makes it easy to add various social logins so that your users can have consistent login experience.",
  //   },
  //   effect: {
  //     title: "Login component access effect",
  //   },
  //   compare: {
  //     title: "Login component VS Customization UI",
  //     "item-one": {
  //       title: "Authing Universal Login Form Guard",
  //       "list-one":
  //         "Beautiful design that fits most modern websites with just a few tweaks to its options.",
  //       "list-two": "Cross-platform support.",
  //       "list-three":
  //         "The initialization has detailed parameters that control the behavior of the entire form.",
  //       "list-four":
  //         "Support for cumbersome and redundant functions such as mobile-password, email-password, forgotten password, password reset, etc.",
  //       "list-five": "Secure authentication by Authing.",
  //     },
  //     "item-two": {
  //       title: "Custom UI",
  //       "list-one":
  //         "Your company has strict design requirements and uniformity requirements for the UI.",
  //       "list-two":
  //         "Your company would like to make changes to the existing UI.",
  //       "list-three":
  //         "Allow front-end development experts to customize with HTML, CSS and JavaScript.",
  //       "list-four": "Secure authentication by Authing.",
  //     },
  //   },
  // },
  guard: {
    banner: {
      title: "Universal Login",
      subtitle:
        "The Universal Login (Guard) is an embeddable login form that can be configured according to your needs and easily add various social login methods, allowing users to log in seamlessly and have a consistent login experience on different platforms.",
    },
    advantageData: {
      0: {
        label: "annual verification",
        value: `100 M+`,
      },
      1: {
        label: "SDK",
        value: `1000+`,
      },
      2: { label: "availability and stability", value: "99.99%" },
    },
    freamwork: {
      title: "User's secure login infrastructure",
      subtitle:
        "Use custom, secure unified login to authenticate users in all apps.",
      descript:
        "The Guard helps developers shield the details of the underlying authentication and tedious UI development. It enables enterprises and developers to quickly launch a secure, customizable UI unified login form.",
    },
    features: {
      title: "Multiple capabilities, empowering user login experience",
      item1: {
        title: "Rich login and registration methods",
        subtitle:
          "Account password / phone verification / APP scan code / corporate identity source / social login.",
      },
      item2: {
        title: "Multiple features, no need to write additional code",
        subtitle:
          "Built-in interactive UI for forgetting the password, MFA function, users do not need to write any additional code to complete tasks.",
      },
      item3: {
        title: "Responsive layout",
        subtitle:
          "Perfectly compatible with mobile and PC, you can easily customize the login box style with CSS.",
      },
      item4: {
        title: "Compatible with all front-end frameworks",
        subtitle:
          "Including login components such as React, Vue, Angular, JavaScript, etc.",
      },
    },
    flexibility: {
      title: "Easily embed in any app, flexibly define the login method",
      subtitle:
        "Guard will be the preferred method for implementing embedded login.",
      descript:
        "Guard can be easily embedded in your apps, customized to enable multiple social providers, and designed according to your brand.</br></br>If you want to be able to make changes to the existing UI, you can customize it with HTML, CSS and JavaScript.",
      // descript1:
      //   "如果你对 UI 有严格的设计要求和统一性要求，希望能在现有 UI 上做改动。Guard 允许前端开发专家使用 HTML，CSS 和 JavaScript 进行自定义。",
    },
  },
  verifyPage: {
    banner: {
      title: "Number Verification",
      subtitle:
        "Relying on the real-name user information on the official WeChat website, users can complete registration/login with real numbers with one-click authorization, and establish an account system based on mobile phone numbers for developers.",
    },
    advantageData: {
      0: { label: "Simplify the login process", value: "51%" },
      1: { label: "Can be authenticated without a SIM card", value: "100%" },
      2: { label: "Reduce the difficulty of operation", value: "81%" },
    },
    intro: {
      title: "Use the Mini Program to scan the QR code on the web",
      descript:
        "After opening the QR code to scan the QR code in Authing, you can get the official real-name user information of WeChat. The user can complete the registration or login with the real number with one-click authorization, and establish a mobile phone number-based account system for developers.",
      descript1: "You can ",
      weixinLogin: "click here to experience the mini program scan code login",
    },
    "step-one": {
      title:
        "Step 1: Create a Mini Program on the WeChat public platform (optional)",
      descript1:
        "By default, Mini Program scan code login will use the default Mini Program provided by Authing. If you need to have stronger brand customization capabilities, or you want to connect the WeChat account of users who log in through Mini Program scan code to their other WeChat public platforms , You need to apply for your own mini program. If you belong to one of these two scenarios:",
      descript2: "Please go to",
      descript3:
        "guide to create a WeChat Mini Program, you need to record the App ID and App Secret of the application, which will be used later.",
      descript4:
        "At the same time, you need to contact us to get the source code of the small login, ",
      weixinPlatform: " the WeChat public platform ",
      consult: "click for details to consult",
    },

    "step-two": {
      title:
        "Step 2: Configure the Mini Program scan code application in the Authing console",
      descript:
        "On the social login configuration page of the console, find the WeChat Mini Program to scan the code to log in, and fill in the following configuration:",
      list1:
        "Logo: The uploaded Logo will be used as the Logo in the center of the QR code of the Mini Program;",
      list2:
        "Callback link after login: This link is usually filled with your business address. If this link is configured, after the user completes the login, the browser will jump to the page with the user information;",
      list3:
        "AppID: AppID of the Mini Program, filled in by the user who chooses to privatize the Mini Program;",
      list4:
        "AppSecret: AppSecret of the Mini Program, filled in by the user who chooses to privatize the Mini Program",
    },
    "step-three": {
      title: "Step 3: Start to develop access",
      descript:
        "Mini program scan code login supports three access methods: using JavaScript SDK, using embedded login components, and using hosted login page. Each access method has its own advantages and disadvantages.You can choose the right way according to your business needs.",
      item1: {
        title: "JavaScript SDK",
        list1: "Easy access, only a few lines of code",
        list2: "Highest degree of customization",
      },
      item2: {
        title: "Embed login component",
        list1: "Easy access, only a few lines of code",
        list2: "You can integrate the component into your application",
        list3: "Relatively high degree of customization",
      },
      item3: {
        title: "Hosted landing page",
        list1:
          "Simple operation and maintenance, Authing is responsible for operation and maintenance",
        list2: "Each application has an independent second-level domain name",
        list3: "Cannot be embedded in your app",
      },
    },
  },
  verify: {
    banner: {
      title: "Authenticate his number without inserting a card",
      subtitle:
        "Relying on the official real name user information of wechat, users can complete registration / login with real number by one click authorization, and establish an account system based on mobile phone number for developers.",
      userInfo: "Login successfully, your personal information",
    },
    scan: {
      wx: "Scan code with wechat",
      modal: {
        "modal-tip": "Login succeeded. Here is your personal information",
        doc: "Doc",
        "ordinary-mode": "Switch normal",
        "json-mode": "Switch json",
        welcom: "Welcome to the authorized mobile phone number",
        "base-info": "Basic Information",
        username: "Username",
        phone: "Authorized phone",
        time: "Authorized time",
        "user-id": "User ID",
        "userpool-id": "Userpool ID",
        "open-id": "Open ID",
        "address-info": "Address information",
        city: "City name",
        country: "Country name",
        region: "region",
        "client-ip": "Client IP",
      },
    },
    product: {
      title: "Product",
    },
    example: {
      title: "Customer Case",
      "item-one": {
        title: "Sentence interaction",
        descript:
          "As a chatting robot company, authing small login program reduces our SMS rate by at least 51% a year. It simplifies the login process and solves the problem well …",
      },
      "item-two": {
        title: "Higher Education Press",
        descript:
          "After giving the login and authentication to Authing, our engineers can focus more on the product itself. Authing's user management background is concise and professional, and the charge is cheaper than other service providers.",
      },
      "item-three": {
        title: "Memect",
        descript:
          "Authing enables us to deploy applications without considering the user system, which can quickly ensure the security of our external business, and at the same time, it can control the users who access, and facilitate the analysis of user pictures…",
      },
    },
    price: {
      title: "Product Price",
      "item-one": {
        title: "3,000 package for number authentication",
        detail: "0.05 yuan / time, total price is 150 yuan",
      },
      "item-two": {
        title: "7,200 package for number authentication",
        detail: "0.035 yuan / time, total price is 2,520 yuan",
      },
      "item-three": {
        title: "450,000 package for number authentication",
        detail: "0.03 yuan / time, total price is 13,500 yuan",
      },
    },
  },
  database: {
    banner: {
      title: "Custom database connection",
      subtitle:
        "When you want to ensure data security or smooth migration of users, please use Authing custom database connection, which can not only connect to the external or local database maintained by yourself, but also migrate the existing user data of the old system to Authing.",
    },
    intro: {
      description:
        "User-defined database connection can decouple Authing from the database. In a traditional software system, the application system and data source should be kept in the same network environment. If an external data source needs to be connected, a lot of docking development work needs to be done. The user-defined database connection of Authing can be highly configurable according to the needs of users. It not only supports standard database solutions such as MySQL, MongoDB, and PostgreSQL but also supports data source docking in API mode. The user-defined script can be run in a virtual sandbox environment, which greatly improves the security of data.",
    },
    sence: {
      title: "Usage scenarios",
      subtitle:
        "Use a custom database connection when you want to provide access to your independent identity database for the following purposes",
      item1: {
        title: "Full control of user data",
        subtitle:
          "You don't want third-party providers to keep your user data.",
      },
      item2: {
        title: "Authentication",
        subtitle:
          "Use your database as an identity provider for Authing to authenticate users.",
      },
      item3: {
        title: "Migrating users",
        subtitle:
          "Inert migration of user data to Authing without user perception.",
      },
    },
    advantage: {
      title: "Product advantages",
      list1:
        "Using a custom database connection can save time and improve work efficiency.",
      list2: "It can be adapted to a variety of scenes with high flexibility.",
      list3:
        "Fully grasp the user data, there is no risk of user data leakage.",
      list4:
        "At present, only Authing supports custom database connections in domestic identity cloud manufacturers, so there is no need to customize it, which can reduce the access cost of old application systems.",
    },
    solution: {
      title: "The typical database connection scheme",
      item1: {
        title: "Using the database provided by Authing",
        list1:
          "Authing provides a database infrastructure to store your users by default. Since all data is stored in Authing, this scheme provides the best performance for the authentication process.",
        list2:
          "The database hosted by Authing is highly secure. Passwords are not stored or logged in as plain text, but are hashed using bcrypt. In addition, various levels of password security requirements can be implemented.",
      },
      item2: {
        title: "Use custom database connection",
        list1:
          "If you have an existing user store or want to store user credentials on your own server, Authing can connect to your configured custom database connection and use it as an identity source.",
        list2:
          "In this case, you provide a login script to authenticate the user that was executed when you tried to log in. Essentially, you can use custom scripts to connect to any kind of database or web service.",
      },
      item3: {
        title: "Migration from the custom database to Authing",
        list1:
          "If your user data is stored in the database of the original system, you want to migrate users to Authing. At this time, Authing provides an automatic migration function, which can automatically add your users to the Authing database every time you log in, and avoid requiring your users to reset their passwords.",
      },
    },
    table: {
      title:
        "Comparison of customized database connection capability between manufacturers",
      subtitle:
        "At present, there are only two manufacturers in the world that support user-defined database connection functions, namely foreign auth0 and domestic Authing.",
      manufacturer: "Manufacturer",
      supported: "Wether Support",
      item1: {
        title: "Authing",
        supported: "Support",
      },
      item2: {
        title: "Auth0",
        supported: "Support",
      },
      item3: {
        title: "Okta",
        supported: "No support",
      },
      item4: {
        title: "Alibaba cloud IDaaS",
        supported: "No support, customized development is required",
      },
      item5: {
        title: "Yufu",
        supported: "No support",
      },
      item6: {
        title: "Zhuyun",
        supported: "No support",
      },
    },
  },
  databasePage: {
    banner: {
      title: "Custom Database Connections",
      subtitle:
        "When you want to ensure data security or smoothly migrate users, please use Authing to customize database connections. You can connect to external or local databases maintained by yourself, and you can also migrate existing user data from the old system to Authing.",
    },
    advantageData: {
      0: { label: "improve efficiency", value: "79%" },
      1: { label: "prevent data leakage", value: "100%" },
      2: { label: "reduce access costs", value: "90%" },
    },
    solutions: {
      title: "Highly configurable database solution",
      descript:
        "The custom database connection can decouple Authing from the database and is highly configurable according to user needs. It not only supports standard database solutions such as MySQL, MongoDB, and PostgreSQL, but also supports data source docking in API mode through a virtual sandbox. The environment runs user-defined scripts, which greatly improves data security.",
    },
    sence: {
      title: "Use scenarios for custom database connections",
      descript: "By using the custom database connection, you can get:",
      list1:
        "Complete control of user data: You do not want third-party service providers to save your user data.",
      list2:
        "Authentication: Use your database as an identity provider for Authing to authenticate users.",
      list3:
        "User migration: Lazy migration of user data to Authing without user perception.",
    },
    "solution-docs": {
      title: "Custom database connection scheme",
      item1: {
        title: "Use the database provided by Authing",
        descript:
          "Authing provides a highly secure database infrastructure to store your users by default. In addition, various levels of password security requirements can be implemented, and passwords are not stored or logged in in plain text, but are hashed using bcrypt.",
      },
      item2: {
        title: "Use a custom database connection",
        descript:
          "If you want to store user credentials on your own server, Authing can connect to a custom database connection you configure and use it as an identity source. Essentially, you can use custom scripts to connect to any kind of database or Web service.",
      },
      item3: {
        title: "Migrating from a custom database to Authing",
        descript:
          "If your user data is stored in the database of the original system, you want to migrate users to Authing. At this time, Authing provides an automatic migration function, which can automatically add your users to the Authing database every time you log in, and avoid requiring your users to reset their passwords.",
      },
    },
    table: {
      title: "Comparison of Vendors of Custom Database Connection Capability",
      subtitle:
        "Currently, there are only two vendors in the world that support custom database connection functions, namely Auth0 abroad and Authing in China.",
      manufacturer: "Manufacturer",
      supported: "Support or Not",
      item1: {
        title: "Authing",
        supported: "Support",
      },
      item2: {
        title: "Auth0",
        supported: "Support",
      },
      item3: {
        title: "Okta",
        supported: "No support",
      },
      item4: {
        title: "Alibaba cloud IDaaS",
        supported: "No support, customized development is required",
      },
      item5: {
        title: "Yufu",
        supported: "No support",
      },
      item6: {
        title: "Zhuyun",
        supported: "No support",
      },
    },
  },
  authority: {
    banner: {
      title: "Authorization Management",
      subtitle:
        "The feature of user management is our way to meet the design requirements of complex organizational structure in large systems by combining resources, roles, and authority authorization into a unified permission grouping for easy management by developers.",
    },
    advantageData: {
      0: { label: "Increased efficiency", value: "75%" },
      1: { label: "Reduced management difficulty", value: "40%" },
      2: { label: "Users are benefiting", value: "3000W+" },
    },
    features: {
      item1: {
        title: "What is RBAC",
        descript:
          "Role-based access control (RBAC), which refers to the authorization of privileges to users through their roles (Role), enables more flexible access control and is simpler, more efficient, and more scalable than granting privileges directly to users.",
        sub: {
          title: "RBAC Application Scenarios",
          descript:
            "For example, the user system has Admin, Maintainer, Operator three roles, these three roles have different permissions . For example, only Admin has the permission to create code repository, delete code repository, the other roles do not have.",
        },
      },
      item2: {
        title: "What is ABAC",
        descript:
          "Attribute-Based Access Control (ABAC) is a very flexible authorization model. Unlike RBAC, ABAC uses various attributes to dynamically determine whether an operation can be allowed.",
        sub: {
          title: "ABAC Application Scenario",
          list1:
            "Authorize editing privileges for Editor A for a specific book.",
          list2:
            "Granting a user access to a document when the document belongs to the same department as the user's department.",
          list3:
            "Prohibit people from department A from accessing system B until 9:00 a.m.",
          list4:
            "Prohibit access to System A as an administrator in places other than Shanghai.",
          descript:
            "Overall, you can granularly authorize the circumstances under which a resource has a particular permission.",
        },
      },
      item3: {
        title: "Authing's Model",
        descript1:
          "In Authing's permission system, we implement the RBAC model of role permission inheritance through two kinds of objects: user and role, and on top of that, we can dynamically and granularly authorize around attributes, thus realizing the ABAC permission model.",
        descript2:
          "At the same time, in order to meet the design requirements of complex organizational structures in large systems, we combine resources, roles, and permissions into a unified permission grouping, which is convenient for developers to manage.",
      },
    },
    model: {
      title: "Choose ABAC if the following conditions are met.",
      item1: {
        title: "You are in a large organization with many users.",
        list1: "You need in-depth, specific access control functionality.",
        list2: "You have time to invest in a remote model.",
        list3: "You need to ensure privacy and security compliance.",
      },
      item2: {
        title: "However, consider RBAC if the following conditions are met.",
        list1: "You are in a small to medium-sized business.",
        list2: "You have an extensive access control policy.",
        list3:
          "You have few external users and your organizational roles are clearly defined.",
      },
    },
  },
  common: {
    "check-doc": "View document",
    "contact-us": "contact us",
  },
};
